<template>
  <div>
    <nav-bar/>
    <div class="pt-4 mx-3">
      <!-- v-if="companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b" -->
      <div v-if="companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'" class="card mb-3">
        <div class="card-header">
          <h3 class="my-2"> {{$t('Search.archive_title')}}</h3>
        </div>
        <div class="card-block">
          <div class="row">
            <regular-input
            :value="searchArchive.id"
            @input="searchArchive.id = $event"
            type="text" :placeholder="$t('Search.order')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <div class="col">
              <button class="btn btn-kne-orange" @click="submitSearchArchive()">
                {{$t('Search.submit')}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3 class="my-2"> {{$t('Search.title')}}</h3>
        </div>
        <div class="card-block">
          <div class="row">
            <regular-input
            :value="search.id"
            @input="search.id = $event"
            type="text" :placeholder="$t('Search.order')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.VIN"
            @input="search.VIN = $event"
            type="text" :placeholder="$t('Search.VIN')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.referenceNumber"
            @input="search.referenceNumber = $event"
            type="text" :placeholder="$t('Search.reference')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.source"
            @input="search.source = $event"
            type="text" :placeholder="$t('Search.source')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.pickup"
            @input="search.pickup = $event"
            type="text" :placeholder="$t('Search.pickup')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.delivery"
            @input="search.delivery = $event"
            type="text" :placeholder="$t('Search.delivery')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.billing"
            @input="search.billing = $event"
            type="text" :placeholder="$t('Search.billing')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-select
            :value="search.status"
            @change="search.status = $event"
            :placeholder="$t('Search.status.status')" class="col-12 col-sm-6 col-lg-3 form-group">
              <option value="Dispatch">{{$t('Search.status.dispatch')}}</option>
              <option value="Pick">{{$t('Search.status.pick')}}</option>
              <option value="Transit">{{$t('Search.status.transit')}}</option>
              <option value="Drop">{{$t('Search.status.drop')}}</option>
              <option value="Cancel">{{$t('Search.status.canceled')}}</option>
              <option value="Terminée">{{$t('Search.status.finished')}}</option>
              <option value="Transférée">{{$t('Search.status.transfered')}}</option>
              <option value="Reject">{{$t('Search.status.rejected')}}</option>
              <option value="Attente">{{$t('Search.status.waiting')}}</option>
            </regular-select>
            <regular-input
            :value="search.dateReceptionMin"
            @input="search.dateReceptionMin = $event"
            type="date" placeholder="Date min" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.dateReceptionMax"
            @input="search.dateReceptionMax = $event"
            type="date" placeholder="Date max" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <!-- <regular-input
            :value="search.driver"
            @input="search.driver = $event"
            type="text" :placeholder="$t('Search.driver')" class="col-12 col-sm-6 col-lg-3 form-group"/> -->
            <regular-datalist-driver
            :value="search.driver"
            @input="search.driver = $event.value"
            :secondList="liste"
            :placeholder="$t('Search.driver')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <regular-input
            :value="search.nbSageOne"
            @input="search.nbSageOne = $event"
            type="text" :placeholder="$t('Search.sageone')" class="col-12 col-sm-6 col-lg-3 form-group"/>
            <div class="col-6">
              <button class="btn btn-kne-orange w-100" @click="clear()">
                {{$t('Search.clear')}}
              </button>
            </div>
            <div class="col-6">
              <button class="btn btn-kne-orange w-100" :disabled="!oneInputFilled" @click="submitSearch()">
                {{$t('Search.submit')}}
              </button>
            </div>
          </div>
        </div>
        <paginate-links @change="setLastPage" for="orders" :hide-single-page="true" :limit="5"></paginate-links>
        <paginate ref="paginator" name="orders" tag="div" :list="orders.deliveries" class="" :per="30">
        <div v-if="orders.deliveries.length > 0" class="table-responsive">
          <table class="table table-hover font-grey mb-0 table-sm">
            <thead class="bg-darkgrey">
              <tr>
                <th @click="sortBy('orderNb', false)" class="sortable nowrap">{{$t('OrderCurrent.order')}}<i v-if="sort.current === 'orderNb'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('reference', false)" class="sortable nowrap">{{$t('OrderCurrent.reference')}}<i v-if="sort.current === 'reference'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('source', false)" class="sortable nowrap">{{$t('OrderCurrent.source')}}<i v-if="sort.current === 'source'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('OrderCurrent.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('date', false)" class="sortable nowrap">{{$t('OrderCurrent.date')}}<i v-if="sort.current === 'date'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('pickup', false)" class="sortable nowrap">{{$t('OrderCurrent.pickup')}}<i v-if="sort.current === 'pickup'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('delivery', false)" class="sortable nowrap">{{$t('OrderCurrent.delivery')}}<i v-if="sort.current === 'delivery'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('billing', false)" class="sortable nowrap">{{$t('OrderCurrent.billing')}}<i v-if="sort.current === 'billing'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('status', false)" class="sortable nowrap">{{$t('OrderCurrent.status')}}<i v-if="sort.current === 'status'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('driver', false)" class="sortable nowrap">{{$t('OrderCurrent.driver')}}<i v-if="sort.current === 'driver'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th></th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr v-for="order in paginated('orders')" :key="order.orderNb" :class="{'drop': order.status === 'Drop', 'cancel': order.status === 'Cancel', 'waiting': order.status === 'Attente', 'pick': order.status === 'Pick', 'transit': order.status === 'Transit', 'dispatch': order.status === 'Dispatch', 'reject': order.status === 'Reject', }">
                <td class="nowrap">{{order.orderNb}}</td>
                <th class="nowrap">{{order.reference}}</th>
                <td class="nowrap"><p class="table-fix-width">{{order.source}}</p></td>
                <td class="nowrap">{{order.vin}}</td>
                <th class="nowrap"><p class="table-fix-width">{{getDate(order.date)}}</p></th>
                <th class="nowrap"><p class="table-fix-width">{{order.pickup}}</p></th>
                <th class="nowrap"><p class="table-fix-width">{{order.delivery}}</p></th>
                <th class="nowrap"><p class="table-fix-width">{{order.billing}}</p></th>
                <th class="nowrap">
                  <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
                  <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
                  <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
                  <span v-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
                  <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
                  <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
                  <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
                  <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
                  <span v-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
                  <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
                </th>
                <th class="nowrap"><p class="table-fix-width">{{order.driver}}</p></th>
                <td>
                  <a :href="'#/OrderInfo?orderId=' + order.orderNb">
                    <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')">
                  </a>
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
        </paginate>
        <paginate-links @change="setLastPage" for="orders" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import regularSelect from '../regularSelect.vue'
import regularDatalistDriver from '../regularDatalistDriver.vue'
import {db, dbArchives} from '../../firebase'

export default {
  name: 'Search',
  components: {
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    regularDatalistDriver
  },
  data () {
    return {
      orders: {
        deliveries: []
      },
      searchArchive: {
        id: ''
      },
      search: {
        id: '',
        VIN: '',
        referenceNumber: '',
        source: '',
        pickup: '',
        delivery: '',
        dateReceptionMin: '',
        dateReceptionMax: '',
        status: '',
        driver: '',
        billing: '',
        nbSageOne: ''
      },
      paginate: ['orders'],
      sort: {
        current: 'orderNb',
        desc: true
      },
      invalid: false
    }
  },
  created () {
    if (this.$store.state.search !== null) {
      this.orders = JSON.parse(JSON.stringify(this.$store.state.search))
      this.search = JSON.parse(JSON.stringify(this.$store.state.searchFields))
    }
    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
  },
  methods: {
    setLastPage (toPage, fromPage) {
      this.$store.commit('SET_LAST_PAGE', toPage)
    },
    submitSearch () {
      var query = ''
      this.orders.deliveries = []
      if (this.search.id !== '') query = query + 'orderNb=' + this.search.id + '&'
      if (this.search.VIN !== '') query = query + 'vin=' + this.search.VIN + '&'
      if (this.search.referenceNumber !== '') query = query + 'reference=' + this.search.referenceNumber + '&'
      if (this.search.source !== '') query = query + 'source=' + this.search.source + '&'
      if (this.search.pickup !== '') query = query + 'pickup=' + this.search.pickup + '&'
      if (this.search.delivery !== '') query = query + 'delivery=' + this.search.delivery + '&'
      if (this.search.dateReceptionMin !== '') query = query + 'from=' + Date.parse(this.search.dateReceptionMin) + '&'
      if (this.search.dateReceptionMax !== '') query = query + 'to=' + Date.parse(this.search.dateReceptionMax) + '&'
      if (this.search.status !== '') query = query + 'status=' + this.search.status + '&'
      if (this.search.billing !== '') query = query + 'billing=' + this.search.billing + '&'
      if (this.search.driver !== '') query = query + 'driver=' + this.search.driver
      if (this.search.nbSageOne !== '') query = query + 'sageOne=' + this.search.nbSageOne
      if (query.slice(-1) === '&') query = query.slice(0, -1)
      console.log(query)
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/search/' + this.companyUID + '/' + query).then((response) => {
        console.log(response.data)
        this.$store.commit('SET_LAST_PAGE', 0)
        this.$store.commit('STORE_SEARCH', response.data)
        this.$store.commit('STORE_SEARCH_FIELD', this.search)
        this.orders = response.data
        this.orders.deliveries.reverse()
      }).catch((error) => console.log(error))
    },
    submitSearchArchive () {
      dbArchives.ref('database/transporter/e58ff614-8449-4c3e-90b8-b42a48c2972b/deliveries').child(this.searchArchive.id).once('value').then((snap) => {
        if (snap.val()) {
          this.$router.push({name: 'OrderInfo', query: {orderId: this.searchArchive.id, archive: true}})
        } else {
          this.invalid = true
          console.log('Not valid')
        }
      })
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
    },
    clear () {
      for (var attr in this.search) {
        this.search[attr] = ''
        this.orders.deliveries = []
        this.$store.commit('CLEAR_SEARCH')
      }
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.orders.deliveries.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'date') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  computed: {
    oneInputFilled: function () {
      var hasInput = false
      for (var attr in this.search) {
        if (this.search[attr] !== '') hasInput = true
      }
      return hasInput
    },
    companyUID () {
      return this.$store.state.authorization.company
    }
  },
  mounted () {
    if (this.$store.state.searchLastPage !== 0) this.$refs.paginator.goToPage(this.$store.state.searchLastPage)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder{
  position: fixed;
  right: 1rem;
  bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// Search.vue?7a4843b2